import CustomDotWrapper from './CustomDot.styled'
import { ACTIVE_PIP, INACTIVE_PIP } from '../../../assets/images'
import { getImageSrc } from '../../../utils/local-util'

const CustomDot = (props: any) => {
  const { onClick, active, activePip = ACTIVE_PIP, inActivePip = INACTIVE_PIP, activePipAltText, inActivePipAltText } = props

  return (
    <CustomDotWrapper
      isActive={active}
      onClick={() => onClick()}
      tabIndex={0}
      className='carousel-custom-pip'
      onKeyDown={(e) => {
        if (e.key === 'Enter' || e.key === ' ') {
          onClick()
        }
      }}
      aria-label={`Slide ${props.index + 1}`}
    >
      <img
        src={active ? getImageSrc(activePip) : getImageSrc(inActivePip)}
        className={active ? 'active' : 'inactive'}
        alt={active ? activePipAltText : inActivePipAltText}
        aria-label={`Slide ${props.index + 1}`}
        role='button'
      />
    </CustomDotWrapper>
  )
}

export default CustomDot
